// noinspection AllyPlainJsInspection

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react'
import { MSG_GW_URL, SPEC_ID } from '../../constants'
import { cardinalApi, guard } from '../services/auth.api'

export const msgGwApiRtk = createApi({
  reducerPath: 'msgGwApi',
  tagTypes: ['MsgGw'],
  baseQuery: fetchBaseQuery({
    baseUrl: `${MSG_GW_URL}/${SPEC_ID}/`,
  }),
  endpoints: (builder) => ({
    sendEmail: builder.mutation<boolean | undefined, { templateId: string; recipient: string; variables: { [key: string]: string } }>({
      queryFn: async ({ templateId, recipient, variables }, { getState }, extraOptions, fetchBaseQuery) => {
        const authApi = (await cardinalApi(getState))?.auth
        return guard([authApi], async ([authApi]): Promise<boolean> => {
          const token = await authApi.getBearerToken()
          const result = await fetchBaseQuery({
            url: `process/${templateId}`,
            method: 'POST',
            responseHandler: (response) => response.text(),
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            body: {
              email: recipient,
              ...variables,
            },
          })

          if (result.error) {
            throw new Error('Failed to send email')
          }

          return true
        })
      },
    }),
  }),
})

export const { useSendEmailMutation } = msgGwApiRtk
